export default __webpack_public_path__ + "static/media/AboutMe.81324344.jpg";